import { isChordSymbolIB64Figure } from '../utils/chordSymbols'
import { parseChordSymbolParts, splitFiguredStackFlatDigitBottom } from '../utils/chordSymbolFigureLayout'

function ChordSymbolPartNodes({ parts }) {
  return parts.map((p, i) => {
    if (p.type === 'text') {
      return <span key={i}>{p.text}</span>
    }
    if (p.type === 'stack') {
      if (p.topFlat) {
        return (
          <span key={i} className="chord-fig-col chord-fig-col-flattop">
            <span className="chord-fig-dtop chord-fig-flattop-flat">{p.topFlat}</span>
            <span className="chord-fig-dtop chord-fig-flattop-top">{p.top}</span>
            <span className="chord-fig-ddigit chord-fig-flattop-bottom">{p.bottom}</span>
          </span>
        )
      }
      const fd = splitFiguredStackFlatDigitBottom(p.bottom)
      if (fd) {
        return (
          <span key={i} className="chord-fig-col chord-fig-col-flatdigit">
            <span className="chord-fig-dtop chord-fig-flatdigit-top">{p.top}</span>
            <span className="chord-fig-dbot chord-fig-flatdigit-flat">{fd.flat}</span>
            <span className="chord-fig-ddigit chord-fig-flatdigit-bottom">{fd.digit}</span>
          </span>
        )
      }
      return (
        <span key={i} className="chord-fig-col">
          <span className="chord-fig-dtop">{p.top}</span>
          <span className="chord-fig-dbot">{p.bottom}</span>
        </span>
      )
    }
    if (p.type === 'stack3') {
      return (
        <span key={i} className="chord-fig-col chord-fig-col-3">
          <span className="chord-fig-d3 chord-fig-d3-top">{p.top}</span>
          <span className="chord-fig-d3 chord-fig-d3-mid">{p.mid}</span>
          <span className="chord-fig-d3 chord-fig-d3-bot">{p.bottom}</span>
        </span>
      )
    }
    if (p.type === 'supDigit') {
      return (
        <span key={i} className="chord-fig-supdig">
          {p.digit}
        </span>
      )
    }
    return null
  })
}

function ChordSymbolInner(value) {
  if (isChordSymbolIB64Figure(value)) {
    return (
      <span className="chord-i-fig64-wrap" aria-label="i b6 4">
        <span className="chord-i-fig64-base">i</span>
        <span className="chord-i-fig64-numgrid" aria-hidden>
          <span className="chord-i-fig64-b">b</span>
          <span className="chord-i-fig64-d6">6</span>
          <span className="chord-i-fig64-d4">4</span>
        </span>
      </span>
    )
  }
  const parsed = parseChordSymbolParts(value)
  if (parsed.mode === 'lines') {
    return (
      <span className="chord-fig-lines">
        {parsed.lines.map((line, i) => (
          <span key={i} className="chord-fig-line">
            {line.mode === 'parts' && line.parts.length > 0
              ? <ChordSymbolPartNodes parts={line.parts} />
              : value.split('\n')[i]}
          </span>
        ))}
      </span>
    )
  }
  if (parsed.mode === 'parts' && parsed.parts.length > 0) {
    return (
      <span className="chord-fig-parts-wrap">
        <ChordSymbolPartNodes parts={parsed.parts} />
      </span>
    )
  }
  return value
}

/**
 * @param {{ value?: string | null, em?: boolean, emTitle?: string }} props
 */
export default function ChordSymbol({ value, em, emTitle }) {
  if (value == null || value === '' || value === '—') {
    const dash = '—'
    return em ? <em title={emTitle}>{dash}</em> : dash
  }

  const inner = ChordSymbolInner(value)
  return em ? <em title={emTitle}>{inner}</em> : inner
}
